import { render, staticRenderFns } from "./HolidaysTable.vue?vue&type=template&id=669a8fee"
import script from "./HolidaysTable.vue?vue&type=script&lang=js"
export * from "./HolidaysTable.vue?vue&type=script&lang=js"
import style0 from "./HolidaysTable.vue?vue&type=style&index=0&id=669a8fee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports